module.exports = __webpack_public_path__ + "assets/img/slide-2.56c78dff.png";